import React from "react";
import { Link } from "react-router-dom";
import { Bot, History, MessageSquare, ShieldCheck } from "lucide-react";

const LINKS = [
    {
        to: "/yeni/sistem-gunlugu/audit",
        title: "Denetim İzleri",
        desc: "Kim, ne zaman, hangi kaydı değiştirdi",
        icon: History,
    },
    {
        to: "/yeni/sistem-gunlugu/whatsapp",
        title: "WhatsApp Logları",
        desc: "Legacy WA mesaj geçmişi (gelen/giden)",
        icon: MessageSquare,
    },
    {
        to: "/yeni/sistem-gunlugu/ai-gorevler",
        title: "AI Görevleri",
        desc: "Akıl görev kuyruğu ve durumları",
        icon: Bot,
    },
    {
        to: "/yeni/sistem-gunlugu/ai-oneriler",
        title: "AI Önerileri",
        desc: "Görevlere bağlı AI patch/öneri kayıtları",
        icon: ShieldCheck,
    },
];

export default function SistemGunluguOzetTab() {
    return (
        <div className="p-4 lg:p-6 space-y-6">
            <div>
                <h2 className="text-lg font-semibold text-white">Operasyon Denetim Merkezi</h2>
                <p className="text-sm text-slate-500 mt-1 max-w-2xl">
                    Bu merkez yalnızca izleme amaçlıdır; mevcut API ve kayıtlara dokunulmaz. Detay
                    listeleri gömülü entity ekranları ile açılır.
                </p>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
                {LINKS.map((l) => {
                    const Icon = l.icon;
                    return (
                        <Link
                            key={l.to}
                            to={l.to}
                            className="rounded-2xl border border-white/10 bg-[#0a1018]/80 p-5 hover:border-[#D4AF37]/35 transition flex gap-3"
                        >
                            <Icon className="h-8 w-8 text-[#D4AF37] shrink-0" />
                            <div>
                                <div className="text-sm font-semibold text-white">{l.title}</div>
                                <div className="text-xs text-slate-500 mt-1">{l.desc}</div>
                            </div>
                        </Link>
                    );
                })}
            </div>
            <div className="flex flex-wrap gap-2 text-xs">
                <Link to="/e/audit-loglari" className="text-slate-400 hover:text-[#D4AF37]">
                    Tam ekran denetim →
                </Link>
                <Link to="/e/hesap-hareketleri" className="text-slate-400 hover:text-[#D4AF37]">
                    Hesap hareketleri →
                </Link>
            </div>
        </div>
    );
}
